import { useRouter } from "next/router";

const useAssignmentPreview = () => {
  const { query = {} } = useRouter();
  const { preview_for: previewFor = "" } = query;
  if (previewFor === "assignment") {
    return true;
  }
};

export default useAssignmentPreview;
